import { useQuery } from "react-query";
import request from "./axios";
import { toast } from "react-toastify";

export const useQueries = (url: string, queryKey: (string | number)[], options?: any) => {
    return useQuery(queryKey, () => request(url, "get", null), {
        onError: (error: any) => {
            toast.error(error.response.data.message);
        },
        ...options
    });
}
